import React from 'react';

// TODO(WORK-5055): Extract PageView as a reusable common component to prevent duplication.
export function PageView({
  currentPage,
  formPage,
  previewPage,
}: {
  currentPage: 'form' | 'preview';
  formPage: React.ReactNode;
  previewPage: React.ReactNode;
}) {
  return (
    <div className="page-view-container">
      <div
        className="page-view-content"
        style={{
          transform: `translateX(${currentPage === 'form' ? '0' : '-100%'})`,
        }}
      >
        <div className="page-view-page">{formPage}</div>
        <div className="page-view-page">{previewPage}</div>
      </div>
      <style jsx>{`
        .page-view-container {
          overflow: hidden;
          width: 100%;
          height: 100%;
          position: relative;
        }
        .page-view-content {
          display: flex;
          width: 100%;
          height: 100%;
          transition: transform 0.3s ease-in-out;
        }
        .page-view-page {
          width: 100%;
          min-width: 100%;
          flex-shrink: 0;
          overflow-y: auto;
          overflow-x: hidden;
          box-sizing: border-box;
        }
      `}</style>
    </div>
  );
}
